import { useDispatch, useSelector } from 'react-redux'
import { dispatchGenerateOrderDoc } from 'tennders-common/stores/prompt/action'

const useGenerateDoc = () => {
  const dispatch = useDispatch()
  const transaction = useSelector((state) => state.prompt.generatedoc)
  const generateOrderDoc = (transaction) => dispatch(dispatchGenerateOrderDoc({ transaction }))

  return {
    generateOrderDoc,
    toGenerate: transaction
  }
}

export default useGenerateDoc
